import { useCallback, useEffect } from "react";
import { setAttributes } from "../../utils/parseCodeinjection.cjs";

export const useCodeInjection = (site) => {
    const appendCodeInjectionElements = useCallback((position, codeInjObjs) => {
        const appendedElements = [];

        codeInjObjs.forEach((child) => {
            const ele = document.createElement(child.name);
            setAttributes(ele, child.attr);
            ele.innerHTML = child.html;
            appendedElements.push(ele);
            position.appendChild(ele);
        });
        return appendedElements;
    }, []);
    useEffect(() => {
        const appendedHeadElements = appendCodeInjectionElements(
            document.head,
            site.parsed_codeinjection_head
        );
        const appendedFootElements = appendCodeInjectionElements(
            document.body,
            site.parsed_codeinjection_foot
        );

        return () => {
            const appendedElements = [
                ...appendedHeadElements,
                ...appendedFootElements,
            ];
            appendedElements.length &&
                appendedElements.forEach((ele) => {
                    ele.remove();
                });
        };
    }, [appendCodeInjectionElements, site]);
};
